import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { imagePrefix, pdpApi2 } from '../../../../public/constants/constants';
import apiManager from '../../../utils/apiManager';
import { createSEOPdpURL, isMobile , formatPrice } from '../../../utils/utilityManager';

function HandPickedMini(props) {

  const [productData, setProductData] = useState(null);
  const [pdpPath, setPdpPath] = useState("");

  useEffect(() => {
    getProductDetail();
  }, []);

  const getProductDetail = () => {

    console.log(props.partNumber,'props.partNumber');
    apiManager
      .get(pdpApi2 + props.partNumber)
      .then(response => {
        let itemData;
        if(response.data.data.type=="product"){
          itemData = response.data.data.skuData[0];
          setProductData(itemData);
        }else if(response.data.data.type=="kit"){
          itemData = response.data.data.kitData[0];
          setProductData(itemData);
        }
        console.log(itemData,'props.partNumber2',response.data.data,'123',response);
        const routePath = createSEOPdpURL(itemData.productName, itemData.shortDescription, props.partNumber);
        setPdpPath(routePath);

      })
      .catch(error => { });
  };

  return (

    !isMobile() && productData ?
      <div className="handPickedMini sticky"><a href={pdpPath || ""} target="_blank">
        <div className="hand-picked-mini">
          <div className="item">
            <div className="hand-picked-title">Handpicked for you</div>
            <div className="image">
              { productData&&productData.thumbnail&&<img src={`${imagePrefix}${productData.thumbnail}`} className="image" alt="godrej-interio" />}
            </div>
          </div>
          <div className="item-desc">
            <div className="product-label">
              {productData && productData.productName && productData.productName}
            </div>
            <div className="titlee">
              {productData && productData.shortDescription && productData.shortDescription}
            </div>

            <span className="price">
                            ₹{formatPrice(productData && productData.offerPrice && productData.offerPrice)}
            </span>
            {productData && productData.offerPrice !== productData.actualPrice?
              <span className="mrp">
                <span>
                                MRP {" "}
                </span><span className="mrp-text">
                                ₹{formatPrice(productData && productData.actualPrice && productData.actualPrice)}
                </span>
              </span>
              :null}
            <div className="desc">MRP inclusive of all taxes</div>

            <div className="button">
              <a href={pdpPath || ""} target="_blank">SHOP NOW</a>
            </div>
          </div>
        </div>
      </a>
      </div>

      : ""
  )
}

export default HandPickedMini;
